import { render, staticRenderFns } from "./ControleDocument.vue?vue&type=template&id=c2f5f0c6&scoped=true"
import script from "./ControleDocument.vue?vue&type=script&lang=ts"
export * from "./ControleDocument.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f5f0c6",
  null
  
)

export default component.exports